/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ra_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free readability analyzer. Paste text to get its Flesch Reading Ease, Flesch-Kincaid grade level, and word, sentence, and syllable counts. Runs in your browser.`)
};

const es_ra_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analizador de legibilidad gratuito. Pega un texto para obtener su Flesch Reading Ease, nivel de grado Flesch–Kincaid, y conteos de palabras, oraciones y sílabas. Se ejecuta en tu navegador.`)
};

const de_ra_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenlose Lesbarkeitsanalyse. Fügen Sie Text ein, um den Flesch Reading Ease, die Flesch-Kincaid-Klassenstufe sowie die Anzahl der Wörter, Sätze und Silben zu erhalten. Läuft direkt in Ihrem Browser.`)
};

const nl_ra_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis leesbaarheidsanalisator. Plak tekst om de Flesch Reading Ease, Flesch-Kincaid-graadniveau en woord-, zin- en lettergreeptellingen te verkrijgen. Draait in uw browser.`)
};

const fr_ra_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyseur de lisibilité gratuit. Collez votre texte pour obtenir son indice Flesch Reading Ease, son niveau Flesch–Kincaid et le nombre de mots, phrases et syllabes. S'exécute dans votre navigateur.`)
};

const it_ra_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analizzatore di leggibilità gratuito. Incolla il testo per ottenere il punteggio Flesch Reading Ease, il livello scolastico Flesch-Kincaid e il conteggio di parole, frasi e sillabe. Funziona nel tuo browser.`)
};

const pt_br2_ra_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analisador de legibilidade gratuito. Cole o texto para obter seu Flesch Reading Ease, nível de série Flesch-Kincaid e contagem de palavras, sentenças e sílabas. Funciona no seu navegador.`)
};

const pt_ra_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analisador de legibilidade gratuito. Cole o texto para obter a sua Flesch Reading Ease, o nível de escolaridade Flesch–Kincaid, e a contagem de palavras, frases e sílabas. Funciona no seu navegador.`)
};

const ja_ra_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料の読みやすさ分析ツール。テキストを貼り付けると、Flesch Reading Ease、Flesch–Kincaidグレードレベル、単語数、文数、音節数が表示されます。ブラウザで実行されます。`)
};

const zh_ra_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费的可读性分析工具。粘贴文本即可获取其 Flesch Reading Ease 分数、Flesch-Kincaid 年级水平，以及字数、句数和音节数统计。全部在浏览器中运行。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ra_tool_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ra_tool_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ra_tool_description", locale)
	if (locale === "en") return en_ra_tool_description(inputs)
	if (locale === "es") return es_ra_tool_description(inputs)
	if (locale === "de") return de_ra_tool_description(inputs)
	if (locale === "nl") return nl_ra_tool_description(inputs)
	if (locale === "fr") return fr_ra_tool_description(inputs)
	if (locale === "it") return it_ra_tool_description(inputs)
	if (locale === "pt-BR") return pt_br2_ra_tool_description(inputs)
	if (locale === "pt") return pt_ra_tool_description(inputs)
	if (locale === "ja") return ja_ra_tool_description(inputs)
	return zh_ra_tool_description(inputs)
};